export default {
	state: {
		chave: {}
	},
	getters: {
		"chave": state => state.chave
	},
	mutations: {
		setChave(state, payload) {
			state.chave = payload
		}
	},
	actions: {
		atualizarEstadoChave({ commit }, payload) {
			commit('setChave', payload)
		}
	}
};